import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { FctlblistitemComponent } from '../fctlb/fctlblistitem.component';
import { FcmodalOption } from './fcmodallist.component';
import { FCEVENT } from '../fc';
import { NzModalService } from 'ng-zorro-antd';
import { GridOptions } from 'ag-grid-community';
import { GRIDOPTIONS, GRIDOPSLOCALE } from '../business/fclistdata.business';
/**
 * fc-modallistdataæ°æ®åè¡¨æ¨¡ææ¡
 * 
 * æ°æ®åè¡¨æ¨¡ææ¡ç»ä»¶ã
 * 
 * ç¹å»æé®å¼¹åºåè¡¨æ¨¡ææ¡ã
 * 
 * äºä»¶
 * 
 * 1.éä¸­äºä»¶ï¼selected
 * 
 * 2.è¡ç¹å»äºä»¶ï¼rowClick
 * 
 * 3.è¡åå»äºä»¶ï¼rowDoubleClick
 * 
 */
@Component({
    selector: 'fc-modallistdata',
    template: `
    <div class="fc-listdata">   
        <fc-modallistsearch [fcAppid]="fcAppid" class="fc-search" (fcEvent)="_searchEvent($event);" [fcModalSearchConfig]="{}"></fc-modallistsearch>
        <div *ngIf="_options!==undefined" class="fc-listdata-content">
            <ag-grid-angular  [localeText]="_gridOptions.localeText"
                        style="width: 100%; height: 100%;" 
                        [pagination]="false"
                        [paginationPageSize]="fcOption.fcPaginationPageSize"
                        [rowData]="fcRowData" 
                        [autoSizePadding]="true" 
                        [class]="fcOption.fcClass"
                        [columnDefs]="fcOption.fcFields"
                        [rowGroupPanelShow]="fcOption.fcRowGroupPanelShow" 
                        [enableFilter]="fcOption.fcEnableFilter"
                        enableValue="true" 
                        [rowGroupPanelShow]="rowGroupPanelShow"
                        enableRowGroup="true" 
                        singleClickEdit="false"
                        (cellValueChanged)="_cellStopEdit($event)"
                        [checkboxSelection]="fcOption.fcCheckboxSelection"
                        [rowSelection]="fcOption.fcRowSelection"
                        [enableColResize]="fcOption.fcEnableColResize" 
                        [animateRows]="true"
                        (selectionChanged)="_selected($event)"
                        (rowClicked)="_rowClick($event)"
                        (rowDoubleClicked)="_rowDoubleClicked($event)"
                        [enableSorting]="fcOption.fcEnableSorting" 
                        (gridReady)="_gridReady($event)">
            </ag-grid-angular>
        </div>
        <div class="fc-listdata-content" *ngIf="_options===undefined">
            <ag-grid-angular [localeText]="_gridOptions.localeText"
                            style="width: 100%;height:100%;" 
                            [pagination]="false"
                            [paginationPageSize]="fcOption.fcPaginationPageSize"
                            [rowData]="fcRowData" 
                            [autoSizePadding]="true" 
                            [class]="fcOption.fcClass"
                            [columnDefs]="fcOption.fcFields"
                            [rowGroupPanelShow]="fcOption.fcRowGroupPanelShow" 
                            [enableFilter]="fcOption.fcEnableFilter"
                            enableValue="true" 
                            [rowGroupPanelShow]="rowGroupPanelShow"
                            enableRowGroup="true" 
                            singleClickEdit="false"
                            (cellValueChanged)="_cellStopEdit($event)"
                            [checkboxSelection]="fcOption.fcCheckboxSelection"
                            [rowSelection]="fcOption.fcRowSelection"
                            [enableColResize]="fcOption.fcEnableColResize" 
                            [animateRows]="true"
                            (selectionChanged)="_selected($event)"
                            (rowClicked)="_rowClick($event)"
                            (rowDoubleClicked)="_rowDoubleClicked($event)"
                            [enableSorting]="fcOption.fcEnableSorting" 
                            (gridReady)="_gridReady($event)">
                </ag-grid-angular>
        </div>
        <fc-pagination class="show" [fcTotal]="_pageTotal"  
        [fcPageSize]="_pageSize"  
        [fcPageSizeSelectorValues]="fcPageSizeSelectorValues" 
        (fcEvent)="_paginationEvent($event)" 
        [ngClass]="{'hidden':!fcOption.fcPagination}"></fc-pagination>
    </div>
    `,
    styles: [`
    .fc-listdata{
        width: 100%;
        height:100%;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;    
    }
    :host ::ng-deep .fc-listdata .ant-modal-footer{
        margin-top:20px;
    }
    .hidden{
        display:none;
    }
    .show{
        display:block;
    }
    :host ::ng-deep .fc-listdata .ant-modal-footer{
        margin-top:20px;
    }
    fc-modallistsearch .fc-search{
        height:20%;
    }
    .fc-listdata-content {
        height:400px;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;    
    }
    :host ::ng-deep .ag-theme-blue .ag-paging-row-summary-panel {
        width:auto;
    }
    :host ::ng-deep .ag-theme-blue .ag-paging-button {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 2px;
        cursor: pointer;
        background: #108EE9;
        border: 1px solid #108EE9;
        color: #ffffff;
        transition: all .3s cubic-bezier(.645,.045,.355,1)
    }
    :host ::ng-deep .ag-theme-blue .ag-paging-button:hover{
        background-color: #49a9ee;
        border-color: #49a9ee;
    }
    :host ::ng-deep .ag-theme-blue ag-paging-page-summary-panel {
        white-space: nowrap;
    }
    :host ::ng-deep .ag-theme-blue .ag-row-odd {
        background: #ffffff;
    }
    :host ::ng-deep .ag-theme-blue .ag-row-selected {
        background:rgba(0,0,0,.1);
    }
    :host ::ng-deep .ag-theme-blue .ag-row-hover {
        background:rgba(0,0,0,.05);
    }
    :host ::ng-deep .ag-theme-blue .ag-ltr .ag-cell-no-focus {
        border-right: 1px solid #d9d9d9;
    }
    :host ::ng-deep .ag-theme-blue .ag-cell-no-focus {
        border-bottom: 1px solid #d9d9d9;
    }
    :host ::ng-deep .ag-theme-blue .ag-cell-no-focus:hover {
        background: rgba(0,0,0,.05);
    }
    :host ::ng-deep .ag-theme-blue .ag-cell-focus {
        border-color: #108EE9;
    }
    :host ::ng-deep .ag-theme-blue .ag-header,
    :host ::ng-deep .ag-theme-blue .ag-menu .ag-tab-header {
        background: #108EE9;
    }
    :host ::ng-deep .ag-theme-blue .ag-menu,:host ::ng-deep .ag-theme-blue .ag-filter-header-container {
        border-color: #d9d9d9;
    }
    :host ::ng-deep .ag-theme-blue .ag-paging-panel{
        text-align: center;
    }
    `]
})
export class FcmodallistdataComponent extends FcinputComponent {
    _condition: {};
     /**æ»é¡µæ°*/
    _pageTotal: number;
     /**åé¡µå¤§å°*/
    @Input()
    fcPageSize: number;
    _pageSize: number;
     /**åé¡µç´¢å¼*/
    @Input()
    fcPageNum: number;
    _pageNum: string;
     /**æå®æ¯é¡µå¯ä»¥æ¾ç¤ºå¤å°æ¡*/
    @Input()
    fcPageSizeSelectorValues: number[];
    public _gridApi;
    public _gridColumnApi
    public _gridOptions: GridOptions = {};
    public _selectIds: string[];
    public _selectItems: any[];
    public _selectIndex: number;
    _options: FcmodalOption;
    @Input()
    fcRowData: any[];
    @Input()
    fcOption: GRIDOPTIONS;
    @Input()
    fcCondition: string;
     /**é¡µç è¿æ»¤æ¡ä»¶*/
    _pagesizeCondition: string;
     /**æ¥è¯¢è¿æ»¤æ¡ä»¶*/
    _searchCondition: string;
     /**è¡é»è®¤éä¸­*/
    @Input()
    fcDeafultSelected: any[];
    /**éä¸­*/
    @Input()
    fcSelectObjs:any[];
    @Input()
    test:string='ç½çº¢';
    constructor(public provider: ProvidersService, private subject: NzModalService) {
        super(provider, 'fc-modallistdata');
        this._gridOptions = {};
        this._gridOptions.localeText = GRIDOPSLOCALE.localeText;
        this._gridOptions.icons = GRIDOPSLOCALE.icons;
         /**é¡µç é»è®¤ç¬¬ä¸é¡µ*/
        this._pageNum = '1';
        this._pageSize = 20;
    }
    /**
     * 
     * @param event æ¥è¯¢äºä»¶
     */
    _searchEvent(event: FCEVENT) {
        switch (event.eventName) {
            case 'reset':
                break;
            case 'search':
                this._searchCondition = event.param;
                this.fcReflesh();
                break;
        }
    }
    @Input()
    set options(modalOption: FcmodalOption) {
        this._options = modalOption;
        this.fcOption = modalOption.options;
        this.fcRowData = modalOption.rowData;
        this.fcAppid = modalOption.appId;
        this.fcCondition = modalOption.condition;
        this.fcPageSize = modalOption.pageSize;
        this.fcPageNum = modalOption.pageNum;
        this.fcDeafultSelected= modalOption.deafultSelected;
        this.fcSelectObjs= modalOption.selectObjs;
        if (this.fcPageSize !== undefined && this.fcPageSize !== null) {
            this._pageSize = this.fcPageSize;
        }
        this.ngOnChanges({});
    }
    _afterParentInit() {
        this._selectIds = [];
        this._selectItems = [];
        this._selectIndex = 1;
        if (this.fcPageSize !== undefined && this.fcPageSize !== null) {
            this._pageSize = this.fcPageSize;
        }
        if (this.fcOption === undefined) {
            this.fcOption = {
                 /**ç®è¤é»è®¤ä¸ºbootstrapé£æ ¼*/
                fcClass: 'ag-theme-blue',
                fcHeight: 450,
                fcRowHeight:22,
                fcPaginationPageSize: 20,
                 /**æ¯å¦å¯ç¨æ¥è¯¢*/
                fcEnableSearch: true,
                 /**æ¯å¦å¯ç¨æåº*/
                fcEnableSorting: true,
                 /**æ¯å¦å¯ç¨è¿æ»¤*/
                fcEnableFilter: true,
                 /**æ¯å¦èªå¨è®¾ç½®è¡¨å¤´å¤§å°*/
                fcEnableColResize: true,
                 /**æ¯å¦æ¾ç¤ºå·¥å·æ */
                fcShowToolPanel: true,
                  /**æ¯å¦åé¡µ*/
                fcPagination: true,
                 /**æ¯å¦æ¾ç¤ºåç»*/
                fcRowGroupPanelShow: 'always',
                 /**æ¯å¦å¯ç¨ç¶ææ */
                fcEnableStatusBar: true,
                 /**æ¯å¦å¯ç¨åºåéä¸­*/
                fcEnableRangeSelection: true,
                 /**éä¸­æ¹å¼*/
                fcRowSelection: 'multiple',
                 /**æ¯å¦å¯ç¨æä½å*/
                fcEnableAction: true,
                 /**éä¸­æcheckbox*/
                fcCheckboxSelection: true,
                 /**æ¯å¦å¯ç¨ç¼è¾*/
                fcEnableEdit: false,
                 /**æ¯å¦èªå¨ä¿å­*/
                fcAutoSave: false
            };
        }
        if (this.fcAppid !== '') {
            if (this.fcOption.fcPaginationPageSize === undefined) {
                this.fcOption.fcPaginationPageSize = this.fcApp.PSIZE;
            }
            if (this.fcOption.fcFields === undefined) {
                this.fcOption.fcFields = this.getFieldsConfByAppid(this.fcAppid);
            }
            if (this.fcOption.fcOrder === undefined) {
                this.fcOption.fcOrder = this.fcApp.SORTBY;
            }
        }
        if (this.fcCondition === undefined || this.fcCondition.length === 0) {
            this._condition = {};
        } else {
            this._condition = JSON.parse(this.fcCondition);
        }
        if (!this.fcOption.fcPagination) {
            this.fcReflesh();
        } else {
             /**æ¥è¯¢æ¡ä»¶æ¹åæ¶ï¼è·³è½¬å°ç¬¬ä¸é¡µ*/
            if (this._pageNum !== "1") this._pageNum = "1";
            else {
                this.fcReflesh();
            }
        }
    }
   /**
    * ç¹å»åé¡µäºä»¶
    * @param event 
    */
   _paginationEvent(event: FCEVENT) {
    switch (event.eventName) {
        case 'pageSizeChange': /**æ¯é¡µæ¾ç¤ºå¤å°æ¡*/
            this._pageSize = event.param;
            if (this.fcOption.fcPagination) this.fcReflesh();
            break;
        case 'jumpPage':
             /**è·³å°ç¬¬å é¡µ,ç¬¬ä¸æ¬¡è¿æ¥æ¶ä¸è¦è§¦åï¼å¦åfcReflesh()ä¼æ§è¡ä¸¤æ¬¡*/
            this._pageNum = event.param + "";
            if (this.fcOption.fcPagination) this.fcReflesh();
            break;
    }
}
    /**
    * æ¥è¯¢
    */
    public fcReflesh(): void {
        if (this.fcAppid !== '') {
            let fieldDic = this.appService.getDicByAppid(this.fcAppid);
              /**å¯ç¨èªå®ä¹åé¡µ*/
             if (this.fcOption.fcPagination) {
                if (this.fcPageSize === undefined) {
                    this.fcPageSize = this.fcApp.PSIZE;
                }
                Object.assign(this._condition, {
                    PAGENUM: this._pageNum,
                    PAGESIZE: this._pageSize
                });
            }
            this.pushDestroy(this.appService.findWithQuery(this.fcAppid, this._condition)
                .subscribe(result => {
                    if (result.CODE === '0' && result.DATA.length !== 0) {
                        result.DATA.forEach((item, index) => {
                            item.ROWNUM = index + 1;
                            item.DOACTION = { providers: this.provider, appId: this.fcAppid, parentComponent: this };
                            fieldDic.forEach(dic => {
                                let dicdesc = this.appService.getDicdescByFieldCode(dic, item[dic.FIELDCODE]);
                                if (dicdesc) {
                                    Object.assign(item, dicdesc);
                                }
                            });
                        });
                        this.fcRowData = result.DATA;
                        this._pageTotal = result.TOTALSIZE;
                    } else {
                        this.fcRowData = [];
                        this._pageTotal = 0;
                    }
                }));
            
        }
    }
    /**
 * é»è®¤éä¸­è¡
 * @param ids idéå
 */
    selectRowById(selectObjs: any[]) {
        this._gridApi.forEachNode(node => {
            let filterNode = selectObjs.filter(obj => {
                let keys = Object.keys(obj);
                let flag = true;
                let data = node.data;
                keys.forEach(key => {
                    if (obj[key] !== data[key]) {
                        flag = false;
                    }
                });
                node.setSelected(flag);
            });
        });

    }
    _gridReady(params) {
        this._gridApi = params.api;
        this._gridColumnApi = params.columnApi;
        if (this.fcOption.fcAutoSize === undefined || this.fcOption.fcAutoSize == true) {
             /**å¤§å°éåï¼å¨æéçå±å¹ååé*/
            this._gridApi.sizeColumnsToFit();
             /** èªå¨è°æ´å¤§å°*/
             /** this._gridColumnApi.autosizeAllColumns();*/
        }
         /** this._gridApi.sizeColumnsToFit();*/
         /** this._gridColumnApi.autosizeAllColumns();*/
        if (this.fcDeafultSelected !== undefined) {
            let clearTimer = function (timer) {
                clearInterval(timer);
            }
            const timer = setInterval(() => {
                if (this._gridApi.getSelectedNodes().length > 0) {
                    clearTimer(timer);
                }
                this.selectRowById(this.fcDeafultSelected);
            }, 800);
        }
    }
    /**
     * 
     * @param params å­æä½æé®äºä»¶
     */
    _doAction(params) {
        let param = params.data;
        this.event( params.ACTION, { ACTION: params.ACTION, PARAMS: param, APPID: this.fcAppid });
    }
    /**
     * éä¸­äºä»¶
     * @param params 
     */
    _selected(params) {
        let rows = this._gridApi.getSelectedRows();
        this.fcSelectObjs=rows;
        if (rows.length !== 0) {
            this.event("selected",rows);
             /** this.subject.next(rows);*/
        }
    }

     /**é»è®¤éä¸­äºä»¶*/
    // defaultSelect() {
    //     this._gridApi.forEachNode(function (node) {
    //         if (node.data.DICID === 'AR00BCUSTOMCREDIT') {
    //             node.setSelected(true);
    //         }
    //     });
    // }
    
    _rowClick(params) {
        this.event( "rowClick",params);
    }
    _rowDoubleClicked(params) {
        this.event( "rowDoubleClick",params);
    }
    getPrevObj() {
        if (this._selectIndex === 1) return;
        this._selectIndex = this._selectIndex - 1;
        this._selectIds = [];
        this._selectItems = [];
        let selectedRows = this.fcRowData.filter(item => {
            return item.ROWNUM === this._selectIndex;
        });
        selectedRows.forEach(element => {
            this._selectIds.push(element.ID);
            this._selectItems.push(element);
        });
        return this._selectItems[0];
    }
    getNextObj() {
        if (this._selectIndex === this.fcRowData.length + 1) return;
        this._selectIds = [];
        this._selectItems = [];
        this._selectIndex = this._selectIndex + 1;
        let selectedRows = this.fcRowData.filter(item => {
            return item.ROWNUM === this._selectIndex;
        });
        selectedRows.forEach(element => {
            this._selectIds.push(element.ID);
            this._selectItems.push(element);
        });
        return this._selectItems[0];
    }
    _cellStopEdit(param) {
        let newObj = param.data;
        newObj.oldValue = param.oldValue;
        newObj.newValue = param.newValue;
        let fieldName = param.colDef.field;
        if (fieldName.indexOf('_DICDESC') !== -1) {
            let fieldCode = fieldName.substr(0, fieldName.length - 8);
            let dicdetails = this.appService.getDicByAppFieldcode(this.fcApp, fieldCode);
            let dics = dicdetails.filter(dic => dic.DICDESC === param.newValue);
            newObj[fieldCode] = dics[0].DICVALUE;
            let action = newObj.DOACTION;
            if (this.fcOption.fcAutoSave) {
                this.pushDestroy(this.appService.updateObject(this.fcAppid, newObj).subscribe(result => {
                    if (result.CODE === '0') {
                    }
                    newObj.DOACTION = action;
                }));
            }
        }

        this.event( 'modify', newObj );
    }
    /**
   * è½¬æ¢æag-gridè¯å«çéç½®
   * @param appId åæ°æ®å¯¹è±¡
   */
    private getFieldsConfByAppid(appId: string): any[] {
        let fieldsList = this.fcApp.SYSAPPFIELDS;
        let _this1 = this;
        let fields: any[] = [{
            field: "",
            suppressSizeToFit: true,
            suppressResize: true,
            suppressMovable: false,
            suppressFilter: true,
            headerCheckboxSelection: this.fcOption.fcCheckboxSelection,
            checkboxSelection: this.fcOption.fcCheckboxSelection,
            suppressSorting: true,
            menuTabs: [],
            sortingOrder: [],
            width: 18
        }, {
            headerName: "åºå·",
            field: "ROWNUM",
            suppressSizeToFit: true,
            suppressResize: true,
            suppressMovable: false,
            suppressFilter: true,
            suppressSorting: true,
            menuTabs: [],
            sortingOrder: [],
            width: 35
        }];
        if (this.fcOption.fcEnableAction) {
            fields.push({
                headerName: "æä½",
                field: "DOACTION",
                enableRowGroup: false,
                enablePivot: false,
                allowedAggFuncs: [],
                suppressMovable: true,
                suppressFilter: true,
                menuTabs: [],
                sortingOrder: [],
                cellRendererFramework: FctlblistitemComponent,
                width: 133
            });
        }
        fieldsList.forEach(element => {
            let width = element.LISTMAXLEN ? (element.LISTMAXLEN * 13 + 10) : (5 * 13 + 10)
            if (element.ENABLE === 'Y' && element.SHOWLIST === 'Y') {
                let field = {
                    headerName: element.FIELDNAME,
                    field: element.FIELDCODE,
                    enableRowGroup: false,
                    enablePivot: true,
                    width: width,
                    allowedAggFuncs: [],
                    cellClass: 'text-left',
                    headerTooltip: element.FIELDNAME,
                    tooltipField: element.FIELDCODE,
                    editable: this.fcOption.fcEnableEdit && element.ENABLEWRITE === 'Y',
                    cellEditor: 'agTextCellEditor',
                    lockPinned: false,
                    pinned: ''
                };
                if (element.DICCODE !== null) {
                    if (element.ENABLEWRITE === 'N' && !this.fcOption.fcEnableEdit) {
                        field.field = element.FIELDCODE + '_DICDESC';
                    } else {
                        let dics = this.fcApp.SYSDIC.filter(item => item.DICID === element.DICCODE);
                        if (dics.length !== 0) {
                            let dic = dics[0];
                            let values = [];
                            if (dic.DICTYPE === 'LISTVALUE') {
                                dic.SYSDICDETAIL.forEach(item => { values.push(item.DICDESC) });
                                field["cellEditorParams"] = {
                                    values: values
                                }
                                field.cellEditor = 'agSelectCellEditor';
                                field.field = element.FIELDCODE + '_DICDESC';
                            }
                        }
                    }
                }
                if (element.DBTYPE !== 'NUM') {
                    field.enableRowGroup = true;
                    field.enablePivot = true;
                } else if (element.DICCODE !== null || element.DBTYPE === 'NUM') {
                    field.cellClass = "text-center";
                } else {
                    field.cellClass = "text-right";
                    field.allowedAggFuncs = ['sum', 'min', 'max'];
                }
                field["cellRenderer"] = function (params) {
                    params.parentContext = _this1;
                    return cellRenderer(params, element);
                }
                fields.push(field);
            }
        });
        return fields;
    }
}

 /**æ¸²ælistwindowçè¡¨æ ¼åå®¹åè¡¨æ ¼æ ¼å¼å*/
function cellRenderer(params: any, field) {
    if (params.data) {
        if (params.data[params.colDef.field] && params.data[params.colDef.field] !== 'null') {
            return '<span title="' + params.data[params.colDef.field] + '">' + params.data[params.colDef.field] + '</span>';
        } else {
            return '<span title=""></span>';
        }
    }
}
var groupColumn = {
    headerName: "Group",
    width: 200,
    field: 'name',
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: {
        checkbox: true
    }
};

function selectionChanged(event) {
     /** //console.log('Callback selectionChanged: selection count = ' + gridOp*/
}
function rowSelected(event) {
     /** the number of rows selected could be huge, if the user is grouping a*/
     /** to stop the console from clogging up, we only print if in the first */
     /** the node id's are assigned from 0 upwards)*/
    if (event.node.id < 10) {
        var valueToPrint = event.node.group ? 'group (' + event.node.key + ')' : event.node.data.name;
        //console.log("Callback rowSelected: " + valueToPrint + " - " + event.node.isSelected());
    }
}

